/** Produce / moderation error modal opened — disconnect avatar leaving the page. */
export const DISCONNECT_AVATAR_PRESERVE_GENERATION_PAGE =
  'napster:disconnectAvatarPreserveGenerationPage';
